import { render, staticRenderFns } from "./OperationLogManagement.vue?vue&type=template&id=54779b84&scoped=true"
import script from "./OperationLogManagement.vue?vue&type=script&lang=js"
export * from "./OperationLogManagement.vue?vue&type=script&lang=js"
import style0 from "./OperationLogManagement.vue?vue&type=style&index=0&id=54779b84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54779b84",
  null
  
)

export default component.exports